<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="sec-6">
<p id="pA8E" style="margin-bottom: 0em;">
<b>F<span class="small">INDING</span> T<span class="small">HEIR</span> V<span class="small">OICES</span></b> </p>
<p id="pAoc" style="margin-top: 0em;">
<i>Sermons by Women in the Churches of Christ</i> </p>
<p id="pAq0" style="text-align: left;">
<img alt="images/himg-6-1.png" id="Aq0" src="images/himg-6-1.png"/></p>
<p id="pA0a" style="text-indent:0;">
					Copyright © 2015 by D’Esta Love<br/>
					ISBN 978-0-89112-588-4 | LCCN 2015003074<br/>
					Printed in the United States of America</p>
<p id="pz6-2">
					ALL RIGHTS RESERVED | No part of this publication may be reproduced, stored in a
					retrieval system, or transmitted in any form by any means—electronic, mechanical,
					photocopying, recording, or otherwise—without prior written consent. </p>
<p id="pz6-3">
					All scripture quotations, unless otherwise indicated, are taken from the Holy Bible,
					New International Version®, NIV®. Copyright ©1973, 1978, 1984, 2011 by Biblica, Inc.™
					Used by permission of Zondervan. All rights reserved worldwide. </p>
<p id="pz6-4">
					Scripture quotations noted <span class="small">NRSV</span> are taken from the New Revised Standard Version Bible,
					copyright © 1989, the Division of Christian Education of the National Council of
					the Churches of Christ in the United States of America. Used by permission. All rights
					reserved. </p>
<p id="pz6-5">
					Scripture quotations noted <span class="small">RSV</span> are taken from the Revised Standard Version of the
					Bible, copyright 1952 [2nd edition, 1971] by the Division of Christian Education
					of the National Council of the Churches of Christ in the United States of America.
					Used by permission. All rights reserved. </p>
<p id="pz6-6">
					Scripture quotations noted <span class="small">NASB</span> are taken from the New American Standard Bible<sup>®</sup> Copyright
					© 1960, 1962, 1963, 1968, 1971, 1972, 1973, 1975, 1977, 1995 by The Lockman Foundation.
					Used by permission. </p>
<p id="pz6-7">
					Scripture quotations noted <span class="small">NLT</span> are taken from the New Living Translation, Copyright
					©1996, 2004, 2007 by Tyndale House Foundation. Used by permission of Tyndale House
					Publishers, Inc., Carol Stream, IL 60188. All rights reserved. </p>
<p id="pz6-8">
					Scripture quotations noted <i>The Message</i> taken from <i>The Message</i>. Copyright 1993, 1994,
					1995, 1996, 2000, 2001, 2002. Used by permission of NavPress Publishing Group. </p>
<p id="pz6-9">
					Scripture texts in this work noted <span class="small">NABRE</span> are taken from the <i>New American Bible, revised
					edition</i> © 2010, 1991, 1986, 1970 Confraternity of Christian Doctrine, Washington,
					D.C. and are used by permission of the copyright owner. All Rights Reserved. No part
					of the New American Bible may be reproduced in any form without permission in writing
					from the copyright owner. </p>
<hr/>
<p id="pz6-10" style="text-indent:0;">
					LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA<br/>
					Finding their voices : sermons by women in the Church of Christ [edited by] D’Esta
					love.<br/>
					  pages cm<br/>
					ISBN 978-0-89112-588-4<br/>
					1. Churches of Christ--Sermons. 2. Sermons, American--Women authors. I. Love, D’Esta,
					editor.<br/>
					BX7077.Z6A29 2015<br/>
					252’.0663--dc23
					                        2015003074</p>
<hr/>
<p id="pz6-11">
					Cover design by Thinkpen Design, LLC | Interior text design by Sandy Armstrong, Strong
					Design </p>
<p id="pz6-12">
					Cover photo: Stauffer Chapel, Photographer Jake Alba, Courtesy of Pepperdine University
					</p>
<p id="pz6-13" style="text-indent:0;">
					For information, contact:<br/>
					Abilene Christian University Press<br/>
					ACU Box 29138, Abilene, Texas 79699</p>
<p id="pz6-16">
					1-877-816-4455 | <a href="http://www.acupressbooks.com" id="A__X" target="_blank">www.acupressbooks.com</a> </p>
<p id="pz6-17" style="text-align: center;">
					15 16 17 18 19 20 / 7 6 5 4 3 2 1 </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyrightpage.vue?01b3767b